














































import { Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';

class State {
  passWord: string;
  repassWord: string;
  constructor() {
    this.passWord = '' as never;
    this.repassWord = '' as never;
  }
}

@Component
export default class AxAccountChangePasswordDialog extends Mixins(AxPage) {
  on = true;

  state = new State();

  @Prop({ default: () => new I.DataParam() })
  param!: I.DataParam;

  @Prop({ type: String, default: '500px' })
  width!: string;

  @Prop({ type: String, default: '260px' })
  height!: string;

  @Watch('on')
  onSwitchChanged() {
    this.$emit('changed', this.on);
  }

  async onPasswordSaveClicked() {
    if (this.state.passWord === '') {
      await this.showErrorModal('오류', '패스워드을 입력 해주세요.');
      return;
    } else if (this.state.passWord !== this.state.repassWord) {
      await this.showErrorModal('오류', '두개의 입력값이 다릅니다.');
      return;
    }

    this.param.selected[0].password = this.state.passWord;
    this.param.callback();
    this.$emit('changed', this.on);
  }

  async onDialogRowClicked(item: I.SensorExtData) {
    console.log(item);

    const confirm = await this.showConfirmModal(
      '확인',
      `AxACU : ${item.acuID}, 센서 포트: ${item.extID}-${item.portID}<br /><br />선택한 항목이 맞습니까?`
    );
    if (confirm !== 0) return;
    this.param.selected = [item];
    this.param.callback();
    this.on = false;
  }
}
